import { Layers, ListFilter, TrendingUp } from "lucide-react";
import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { AdsTab } from "../components/planner/AdsTab";
import { CatalogueTab } from "../components/planner/CatalogueTab";
import { SegmentsTab } from "../components/planner/SegmentsTab";

type Tab = "catalogue" | "ads" | "segments";

const tabs: { id: Tab; label: string; icon: typeof ListFilter }[] = [
	{ id: "catalogue", label: "Catalogue", icon: ListFilter },
	{ id: "ads", label: "Ads performance", icon: TrendingUp },
	{ id: "segments", label: "Segments", icon: Layers },
];

const Planner = () => {
	const [activeTab, setActiveTab] = useState<Tab>("catalogue");

	return (
		<div className="space-y-6">
			<PageHeader
				kicker="Menu · Planner"
				title="Planner."
				qualifier="What is worth comparing tonight."
				description="The nightly set of genuinely comparable products — carried by 3+ merchants — filterable, saveable and rankable by what Partner-ads actually converts."
			/>

			<div className="border-b border-slate-200">
				<nav className="flex gap-1" aria-label="Tabs">
					{tabs.map((tab) => (
						<button
							key={tab.id}
							type="button"
							onClick={() => setActiveTab(tab.id)}
							className={`flex items-center gap-2 border-b-2 px-5 py-3 text-sm font-medium transition-all ${
								activeTab === tab.id
									? "border-primary text-primary"
									: "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700"
							}`}
						>
							<tab.icon className="h-4 w-4" />
							{tab.label}
						</button>
					))}
				</nav>
			</div>

			{activeTab === "catalogue" && <CatalogueTab />}
			{activeTab === "ads" && <AdsTab />}
			{activeTab === "segments" && <SegmentsTab />}
		</div>
	);
};

export default Planner;
